import glamorous from 'glamorous'

import { hexToRgb } from '../../../../../helpers/styles'

import * as font from '../../../../../styles/typography'
import * as colours from '../../../../../styles/colours'

export const StyledFormTitle = glamorous.h1({
  display: 'flex',
  margin: 0,
  height: 65,
  boxShadow: `0 3px 20px 0 rgba(${hexToRgb(colours.shadow)}, 0.15)`,
  alignItems: 'center',
  justifyContent: 'center',
  color: colours.basicBlMain,
  fontFamily: font.fontMedium,
  fontSize: 20,
  textAlign: 'center',
})



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/LoginForm/components/FormTitle/FormTitle.glamorous.tsx